import InfoIcon from '../../icons/InfoIcon';
import PromotionalTipPanel from './PromotionalTipPanel';
import { Root, Tip } from './styles';
import usePromotionalTip from './vm';

export interface PromotionalTipProps {
  className?: string;
}

const PromotionalTip = ({ className }: PromotionalTipProps) => {
  const {
    promotionalTip,
    isPromotionalTipPanelOpen,
    handlePromotionalTipClick,
    handleClosePromotionalTipPanel,
  } = usePromotionalTip();

  if (!promotionalTip) return null;

  return (
    <>
      <Root className={className} onClick={handlePromotionalTipClick}>
        <Tip icon={<InfoIcon variant="filled" color="inherit" aria-hidden />} color="info" tabIndex={0}>
          <div dangerouslySetInnerHTML={{ __html: promotionalTip.text }} />
        </Tip>
      </Root>
      <PromotionalTipPanel
        isOpen={isPromotionalTipPanelOpen}
        onClose={handleClosePromotionalTipPanel}
        promotionalTip={promotionalTip}
      />
    </>
  );
};

export default PromotionalTip;
